export const getCategoriasLp = state => {
    return state.categoriasLp;
};

export const getUnidadesProcedenciaLP = state => {
    return state.unidadesProcedenciaLP;
};

export const getDadosPacienteLp = state => {
    return state.dadosPacienteLp;
};

